export default (klass) => class SOTFLobbyMixin extends klass {

  static targets = [
    ...super.targets,
    'counter',
    'queueItem'
  ]

  queueItemTargetConnected(queueItem) {
    this.#updateCounter(queueItem.dataset.listName)
  }

  queueItemTargetDisconnected(queueItem) {
    this.#updateCounter(queueItem.dataset.listName)
  }

  // ==== Actions

  // ==== Getters

  // ==== Setters

  // ==== Private

  #updateCounter(listName) {
    this.#getCounterTarget(listName).textContent = this.#getQueueItemCount(listName)
  }

  #getCounterTarget(listName) { return this.#getListTarget('counter', listName) }

  #getListTarget(target, listName) {
    return this[`${target}Targets`]
      .find((counter) => counter.dataset.listName === listName)
  }

  #getQueueItemCount(listName) {
    return this.#getQueueItems(listName).length
  }

  #getQueueItems(listName) {
    return this.queueItemTargets
      .filter((queueItem) => queueItem.dataset.listName === listName)
  }

}
